import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, 
    DialogTitle, Paper } from '@material-ui/core';
import Draggable from 'react-draggable';

function PaperComponent(props) {
    return (
        <Draggable>
            <Paper {...props} />
        </Draggable>
    );
}

class DraggableDialog extends React.Component {
    state = {
        open: false,
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const buttonClose = this.props.showClose ? 
            <Button onClick={() => this.props.handleClose()} color="primary">
                {this.props.t('Text.cancel', { framework: "react-i18next" })}
            </Button> : '';

        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={() => this.props.handleClose()}
                    PaperComponent={PaperComponent}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle id="draggable-dialog-title">{this.props.iconeHeader}{this.props.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {this.props.message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {buttonClose}
                        <Button onClick={() => this.props.handleConfirm()} color="primary">
                            {this.props.t('Text.ok', { framework: "react-i18next" })}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default DraggableDialog;